module.exports = __webpack_public_path__ + "img/agradecimiento_2018.18e9f82f.jpg";